import {environment} from "../../env";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import type {Bag} from "../../services/classes/Bag";
import type {SelectProps} from "@mui/material/Select";
import Select from "@mui/material/Select";
import {AdminPanelSettings, RemoveCircle, VisibilityOff} from "@mui/icons-material";
import {useStores} from "../../stores";
import {Divider} from "@mui/material";

type Props = SelectProps & {
    bags: Bag[]
};
export const SelectDatasetMenu: React.FC<Props> = ({bags, ...selectProps}) => {
    const {authStore} = useStores();
    const showStaffMenu = environment.isTest || authStore.isMithraStaffGroup;
    const visible = bags.filter(b => !b.hidden);

    if (!showStaffMenu) {
        return <Select {...selectProps}>
            {visible.map(bag => <MenuItem key={bag.id} value={bag.id}>
                {bag.name}
            </MenuItem>)}
        </Select>
    } else {
        // Show all other databags as well
        const hidden = bags.filter(b => b.hidden && !b.disabled);
        const disabled = bags.filter(b => b.hidden && b.disabled);

        // Note: We cannot use fragments here
        return <Select {...selectProps}>
            {visible.map(bag => <MenuItem key={bag.id} value={bag.id}>
                <StaffMenuItem bag={bag}/>
            </MenuItem>)}
            {hidden.length > 0 && <Divider/>}
            {hidden.map(bag => <MenuItem key={bag.id} value={bag.id}>
                <StaffMenuItem bag={bag}/>
            </MenuItem>)}
            {disabled.length > 0 && <Divider/>}
            {disabled.map(bag => <MenuItem key={bag.id} value={bag.id}>
                <StaffMenuItem bag={bag}/>
            </MenuItem>)}
        </Select>
    }
}

const StaffMenuItem: React.FC<{ bag: Bag }> = ({bag}) => {
    const icons = [
        bag.hidden ? <VisibilityOff key="hidden" titleAccess="hidden"/> : null,
        bag.disabled ? <RemoveCircle key="disabled" titleAccess="disabled"/> : null,
    ].filter(Boolean);
    return <>
        <AdminPanelSettings/>
        {icons}
        [{bag.id}] {bag.name}
    </>;
}
